import type { Module, Page, Quiz } from '@efdigital/ll-addon-data';
import type { ModelFrom } from '@efdigital/ll-admin-v2/lib/type-utils';
import type ProgramsProgramCohortRoute from '@efdigital/ll-admin-v2/routes/programs/program/cohort';
import type { ParamsModuleId } from '@efdigital/ll-admin-v2/routes/programs/program/cohort/content/module';
import type { ParamsPageId } from '@efdigital/ll-admin-v2/routes/programs/program/cohort/content/page';
import type { ParamsQuizId } from '@efdigital/ll-admin-v2/routes/programs/program/cohort/content/quiz';
import { array } from '@ember/helper';
import { LinkTo } from '@ember/routing';
import Component from '@glimmer/component';

import { SidebarFullscreenButton } from '../sidebar/sidebar-fullscreen-button.gts';

interface ContentBreadcrumbSignature {
  Args: {
    model: ModelFrom<ProgramsProgramCohortRoute> &
      Partial<ParamsModuleId> &
      Partial<ParamsPageId> &
      Partial<ParamsQuizId> & {
        module?: Module;
        page?: Page;
        quiz?: Quiz;
      };
  };
}

export default class ContentBreadcrumb extends Component<ContentBreadcrumbSignature> {
  get showCohortLink() {
    return (
      this.args.model.page_id ||
      this.args.model.module_id ||
      this.args.model.quiz_id
    );
  }

  get showModule() {
    return this.args.model.module_id;
  }

  get showModuleLink() {
    return this.args.model.module_id && this.args.model.page_id;
  }

  get showPage() {
    return this.args.model.page_id;
  }

  get showQuiz() {
    return this.args.model.quiz_id;
  }

  <template>
    <div class="container-fluid">
      <div
        class="d-flex justify-content-center flex-row py-3 shadow-sm align-items-center gap-3"
      >
        <ol class="breadcrumb ll-content-breadcrumb m-0 justify-content-center">
          <li class="breadcrumb-item">
            {{#if this.showCohortLink}}
              <LinkTo
                @route="programs.program.cohort.content.index"
                @models={{array @model.program_id @model.cohort_id}}
                class="btn btn-outline-dark border-0 btn-sm rounded-1"
              ><strong>Cohort</strong> &ndash; {{@model.cohort.title}}</LinkTo>
            {{else}}
              <span
                class="btn btn-outline-dark border-0 btn-sm rounded-1"
              ><strong>Cohort</strong>
                &ndash;
                <em>Editing</em></span>
            {{/if}}
          </li>
          {{#if this.showModule}}
            <li class="breadcrumb-item">
              {{#if this.showModuleLink}}
                <LinkTo
                  @route="programs.program.cohort.content.module.index"
                  @models={{array
                    @model.program_id
                    @model.cohort_id
                    @model.module_id
                  }}
                  class="btn btn-outline-dark border-0 btn-sm rounded-1"
                ><strong>Module</strong>
                  &ndash;
                  {{@model.module.title}}</LinkTo>
              {{else}}
                <span
                  class="btn btn-outline-dark border-0 btn-sm rounded-1"
                ><strong>Module</strong> &ndash; <em>Editing</em></span>
              {{/if}}
            </li>
          {{/if}}
          {{#if this.showPage}}
            <li class="breadcrumb-item">
              <span
                class="btn btn-outline-dark border-0 btn-sm rounded-1"
              ><strong>Page</strong>
                &ndash;
                <em>Editing</em></span>
            </li>
          {{/if}}
          {{#if this.showQuiz}}
            <li class="breadcrumb-item">
              <span
                class="btn btn-outline-dark border-0 btn-sm rounded-1"
              ><strong>Quiz</strong>
                &ndash;
                <em>Editing</em></span>
            </li>
          {{/if}}
        </ol>
        <SidebarFullscreenButton
          class="btn btn-sm btn-white btn-magical-border m-0"
        />
      </div>
    </div>
  </template>
}
